<template>
  <div id="content">
    <transition name="fade" mode="out-in">
      <component :is="currentContent" />
    </transition>
  </div>
</template>

<script>
import EAP from "@/pages/Eap.vue";
import GeneralInfo from "@/pages/GeneralInfo.vue";
import Wellbeing from "../../pages/Wellbeing";
import Article from "@/pages/Article.vue"
import AllArticles from "@/pages/AllArticles.vue"
import Course from "@/pages/Course.vue"
import AllCourses from "../../pages/AllCourses";
import BeCalmCourse from "../../pages/BeCalmCourse";
import BeCalm from "../../pages/BeCalm";

const mappings = {
    'eap': EAP,
    'info': GeneralInfo,
    'wellbeing': Wellbeing,
    'article': Article,
    'allArticles': AllArticles,
    'course': Course,
    'allCourses': AllCourses,
    'not-found': EAP,
    'beCalm': BeCalm,
    'beCalmCourse': BeCalmCourse
};

export default {
  name: "ContentRouter",
  computed: {
    currentContent() {
      return mappings[this.$route.name];
    }
  }
};
</script>
<style lang="less">
  #content{
    min-height: calc(100vh - 200px);
    display: flex;
    justify-content: center;
    &>div{
      width: 100%;
    }
  }
  .fade-enter-active{
    transition-duration: 0.5s;
    transition-property: opacity;
    transition-timing-function: ease-in;
  }
  .fade-leave-active {
    transition-duration: 0s;
    transition-property: opacity;
    transition-timing-function: ease-in;
  }
  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
</style>